import * as actions from './actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import firebase from 'firebase'

function firebaseSignin(email, password) {
  return firebase.auth().signInWithEmailAndPassword(email, password)
}

function firebaseSignout() {
  return firebase.auth().signOut()
}

export function* signin({ payload: { email, password } }) {
  try {
    yield put(actions.signinStart())
    yield call(firebaseSignin, email, password)
    yield put(actions.signinSuccess())
  } catch (err) {
    yield put(actions.signinError(err))
  }
}

export function* signout() {
  try {
    yield call(firebaseSignout)
    yield put(actions.signoutSuccess())
  } catch (err) {
    yield put(actions.signoutError())
  }
}

export default function*() {
  yield takeEvery(actions.signin, signin)
  yield takeEvery(actions.signout, firebaseSignout)
}



// WEBPACK FOOTER //
// ./src/services/signin/sagas.js